import { useEffect, useRef, useState } from "react";
import { InputLabel, OutlinedInput, Tooltip, Typography } from "@mui/material";
import "../../styles/UserDashboard/Kyc.scss";
import {
  requestVerificationToken,
  submitKycBasicGreen,
  submitKycBasicNongreen,
  submitKycBusinessGreen,
  submitKycBusinessMonitoring,
  submitKycBusinessNongreen,
  submitKycGovernanceGreen,
  submitKycGovernanceMonitoring,
  submitKycGovernanceNongreen,
} from "../../apis/UserDashboard/dashboard";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { getDatabase, push, ref } from "firebase/database";
import { getKyc, getUserInfo } from "../../apis/General/users";
import { Onfido } from "onfido-sdk-ui";
import {
  createApplicant,
  createCheck,
  getAuthToken,
  getCheck,
} from "../../apis/General/idVerification";
import jwt_decode from "jwt-decode";
import { useLocation } from "react-router-dom";
import KYCBasicGreenForm from "./KYCBasicGreenForm";
import KYCBasicNonGreen from "./KYCBasicNonGreen";
import KYCGovernanceGreenForm from "./KYCGovernanceGreenForm";
import KYCGovernanceNonGreenForm from "./KYCGovernanceNonGreenForm";
import KYCGovernanceMonitoringForm from "./KYCGovernanceMonitoringForm";
import KYCBusinessGreenForm from "./KYCBusinessGreenForm";
import KYCBusinessNonGreenForm from "./KYCBusinessNonGreenForm";
import KYCBusinessMonitoringForm from "./KYCBusinessMonitoringForm";
import { render } from "react-dom";


const Kyc = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenThree, setModalOpenThree] = useState(false);
  const [loading, setLoading] = useState("");
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [idVerificationModal, setIdVerificationModal] = useState(false);
  const [failedIdVerificationModal, setFailedIdVerificationModal] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState("");
  const [facilityCategory, setFacilityCategory] = useState("");
  const [facilityType, setFacilityType] = useState("");
  const [scenario, setScenario] = useState("");
  const [onfidoInstance, setOnfidoInstance] = useState(null);
  const [preOnfidoInitDone, setPreOnfidoInitDone] = useState(false);
  const [kycLoading, setKycLoading] = useState(true);
  const [organizationBoundary, setOrganizationBoundary] = useState("");
  const [reportingBoundary, setReportingBoundary] = useState("");
  const [historicalInventory, setHistoricalInventory] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [images, setImages] = useState([]);
  const [projectMonitoringReport, setProjectMonitoringReport] = useState("");
  const [projectDescriptionReport, setProjectDescriptionReport] = useState("");
  const [
    descriptionOfRenewableEnergySources,
    setDescriptionOfRenewableEnergySources,
  ] = useState("");
  const [typeofFuel, setTypeofFuel] = useState("");
  const db = getDatabase();
  let retryCount = 0;
  const MAX_RETRIES = 3;

  const createWorkflowRun = async () => {
    const response3 = await getAuthToken(
      auth?.userInfo?.trdPtyKycAppId, //applicant id
      "8d1f453f-991f-457f-bec6-283866d59612", //workflow id
      auth?.token
    );
    console.log("response3?.data?.message?.token", response3);
    if (response3?.data?.statusCode === 200) {
      localStorage.removeItem("token");
      localStorage.setItem("token", response3?.data?.message);

      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          token: response3?.data?.message,
        },
      });
      initOnfido(
        response3?.data?.onfidoResp?.sdk_token,
        response3?.data?.onfidoResp?.id
      );
    }
  };

  const preInitOnfido = async () => {
    // setLoading(true)
    console.log("got here");
    try {
      // setLoading(true);
      console.log("started1");

      if (!auth?.userInfo?.trdPtyKycAppId) {
        const response1 = await getUserInfo(auth?.userInfo?.id, auth?.token);
        console.log("response1", response1);
        const response2 = await createApplicant(
          response1?.data?.message?.firstName,
          response1?.data?.message?.lastName,
          response1?.data?.message?.email,
          auth?.token
        );

        console.log("create applicant", response2);

        if (response2?.data?.statusCode === 200) {
          localStorage.removeItem("token");
          localStorage.setItem("token", response2?.data?.message);

          dispatch({
            type: "USER_LOGIN_SUCCESS",
            payload: {
              token: response2?.data?.message,
            },
          });
          console.log("auth", auth);
        } else {
          toast.error(response2?.data?.message);
          // setLoading(false);
          return;
        }
      }

      createWorkflowRun();
    } catch (err) {
      console.log("err:", err.message, err.request);
      // setLoading(false);
      return;
    }
  };
  const initOnfido = async (token, workflowRunId) => {
    // setLoading(true);

    if (onfidoInstance) {
      console.log("Onfido instance already exists. Skipping initialization.");
      // setLoading(false)
      return;
    }

    setIdVerificationModal(true);
    console.log("massive", token, workflowRunId);
    try {
      onfidoInstance = Onfido.init({
        // useModal: false,
        token,
        containerId: "onfido-mount",
        onComplete: async (data) => {
          setTimeout(async () => {
            console.log("Everything is complete", data);
            setIdVerificationModal(false);
            toast.success("ID Verification in progress");
            push(ref(db, "notifications"), {
              type: "ID Verification in progress",
              read: false,
              user: auth?.userInfo?.id,
              timestamp: Date.now(),
            });
            const response = await getCheck(
              auth?.userInfo?.kycCheckId,
              auth?.token
            );
            console.log("response check onfido", response);
            console.log("jwt_decode(response?.data?.message)?.trdPtyKycStatus", jwt_decode(response?.data?.message)?.trdPtyKycStatus);
            console.log("get over here");
            localStorage.removeItem("token");
            localStorage.setItem("token", response?.data?.message);
            dispatch({
              type: "USER_LOGIN_SUCCESS",
              payload: {
                token: response?.data?.message,
              },
            });
          }, 4000);
        },
        onError: async (error) => {
          console.log("error from Onfido", error);
          if (
            // (error?.type === "invalid_token" ||
            //   error?.type === "expired_token") &&
            retryCount < MAX_RETRIES
          ) {
            retryCount++;
            // if (auth?.userInfo?.trdPtyKycStatus === "awaiting_input") {
            //   //run request token function before initOnfido
            //   const response = await requestVerificationToken(
            //     auth?.userInfo?.trdPtyKycAppId,
            //     auth?.token
            //   );
            //   console.log("new token from onfido", response);
            //   console.log(
            //     "response?.data?.onfidoResp?.token",
            //     response?.data?.onfidoResp?.token
            //   );
            //   if (response?.status === 200) {
            //     initOnfido(
            //       auth?.userInfo?.kycCheckId,
            //       response?.data?.onfidoResp?.token
            //     );
            //   } else {
            //     alert("Unable to retrieve new token. Please contact support");
            //   }
            // } else {
            //   preInitOnfido();
            // }
            preInitOnfido();
          } else {
            alert("Max retries reached");
            console.log("Max retries reached");
            setIdVerificationModal(false);
            // Handle the error appropriately
          }
        },
        workflowRunId,
      });
    } catch (error) {
      console.log("there is error", error);
    }

    // setLoading(false);
  };

  // useEffect(() => {
  //   preInitOnfido();
  // }, []);
  // useEffect(() => {
  //   initOnfido();
  //   return () => {
  //     console.log("tear down", onfidoInstance);
  //     onfidoInstance && onfidoInstance.tearDown();
  //   };
  //   // }
  // }, [preOnfidoInitDone]);

  const checkOnfidoKycStatus = async () => {
    console.log("deyyah");
    console.log("checkId", auth?.userInfo?.kycCheckId);

    const response = await getCheck(
      auth?.userInfo?.kycCheckId,
      auth?.token
    );
    console.log("getCheck", response);

    dispatch({
      type: "USER_LOGIN_SUCCESS",
      payload: {
        token: response?.data?.message,
      },
    });
    const currenStatus = jwt_decode(response?.data?.message)?.trdPtyKycStatus;
    console.log('currenStatus', currenStatus);

    if (currenStatus === "approved") {
      return;
    }
    else if (
      currenStatus === "declined" ||
      currenStatus === "error" ||
      currenStatus === "abandoned" ||
      currenStatus === "n/a" ||
      currenStatus === "review"
    ) {
      toast.error("ID verification failed. Please try again")
      preInitOnfido();
    }
    else if (
      currenStatus === "processing"
    ) {
      return;
    } else if (currenStatus === "awaiting_input") {
      console.log("auth for onfido", auth);
      //run request token function before initOnfido
      initOnfido(auth?.userInfo?.onfidoSdkToken, auth?.userInfo?.kycCheckId);
    }
  };

  // useEffect(() => {
  //   console.log("auth", auth);
  //   if (auth?.userInfo?.kycStatus !== "N/A") {
  //   checkOnfidoKycStatus();
  //   }
  // }, [location]);

  useEffect(() => {
    if (auth?.userInfo?.kycStatus === "N/A") {
      setModalOpen(true);
    }
  }, []);

  const handlegetKyc = async () => {
    const response = await getKyc(auth?.userInfo?.id, auth?.token);
    console.log("kyc for user", response);

    setSubscriptionPlan(response?.data?.message?.subscriptionPlan);
    setFacilityCategory(response?.data?.message?.facilityCategory);
  };

  useEffect(() => {
    handlegetKyc();
  }, []);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = (e) => {
    if (e.target.classList.contains("kyc_modal_container")) {
      setModalOpen(false);
    }
  };

  const handleModalOpenThree = () => {
    setModalOpenThree(true);
  };

  const handleModalCloseThree = (e) => {
    if (e.target.classList.contains("kyc_modal_container")) {
      setModalOpenThree(false);
    }
  };
  const handleKycSubmit = async (formData) => {
    // if (doubleCounting === "true") {
    //   alert(
    //     "Projects receiving or seeking credit for reductions and removals from a project activity under another GHG program are not accepted on CloseCarbon"
    //   );
    //   return;
    // } else if (Date.now() > Date.parse(projectEndDate)) {
    //   alert("Project end date can not be in the past");
    //   return;
    // } else if (Date.parse(projectStartDate) > Date.parse(projectEndDate)) {
    //   alert("Project start date can not be ahead of Project end date ");
    //   return;
    // }
    setLoading(true);
    let response;

    if (subscriptionPlan === "basic" && facilityCategory === "green") {
      // Map form data to API expected field names 

      const mappedFormData = {
        greenProjectName: formData.facilityName,
        greenProjectDescription: formData.facilityDescription,
        greenProjectLocation: formData.facilityLocation,
        greenProjectLicenseId: formData.greenProjectLicenseId,
        greenProjectStartDate: formData.projectStartDate,
        greenProjectEndDate: formData.projectEndDate,
        renewableEnergySolutions: formData.renewableEnergy,
        baseLineScenario: formData.baseline,
        baseLineEnergySource: formData.nonRenewableEnergySource === 'others'
          ? formData.nonRenewableEnergySourceOther
          : formData.nonRenewableEnergySource,
        additionalInfomation: formData.additonalInfo,

      };

      response = await submitKycBasicGreen(
        facilityCategory,
        subscriptionPlan,
        mappedFormData.greenProjectName,
        mappedFormData.greenProjectDescription,
        mappedFormData.greenProjectLocation,
        mappedFormData.greenProjectLicenseId,
        mappedFormData.greenProjectStartDate,
        mappedFormData.greenProjectEndDate,
        mappedFormData.renewableEnergySolutions,
        mappedFormData.baseLineScenario,
        mappedFormData.baseLineEnergySource,
        mappedFormData.additionalInfomation,
        formData.proofOfFuelSource,
        formData.justificationStatement,
        auth?.token
      );
    }
    else if (
      subscriptionPlan === "basic" &&
      facilityCategory === "non-green"
    ) {
      // Map form data to API expected field names 
      const mappedFormData = {
        baseLineFuelSource: formData.fuelSourceBaseline,
        projectFuelSource: formData.fuelSource === 'others'
          ? formData.fuelSourceOther
          : formData.fuelSource,
        baseLineScenario: formData.baseline,
        additionalInfomation: formData.additonalInfo,
        facilityStartDate: formData.projectStartDate,
        facilityEndDate: formData.projectEndDate,
      }
      response = await submitKycBasicNongreen(
        facilityCategory,
        subscriptionPlan,
        formData.facilityName,
        formData.facilityDescription,
        formData.facilityLocation,
        mappedFormData.facilityStartDate,
        mappedFormData.facilityEndDate,
        mappedFormData.projectFuelSource,
        mappedFormData.baseLineScenario,
        mappedFormData.baseLineFuelSource,
        mappedFormData.additionalInfomation,
        formData.proofOfFuelSource,
        formData.justificationStatement,
        auth?.token
      );
    } else if (
      subscriptionPlan === "governance" &&
      facilityCategory === "carbon-monitoring"
    ) {
      const mappedFormData = {
        generatorFuelType: formData.generatorFuelType === 'others'
          ? formData.generatorFuelTypeOther
          : formData.generatorFuelType,
        gridElectricityUsage: formData.usesGridElectricity,
        facilityStartDate: formData.projectStartDate,
        facilityEndDate: formData.projectEndDate,
      }
      response = await submitKycGovernanceMonitoring(
        facilityCategory,
        subscriptionPlan,
        formData.facilityName,
        formData.facilityDescription,
        formData.facilityLocation,
        mappedFormData.facilityStartDate,
        mappedFormData.facilityEndDate,
        mappedFormData.generatorFuelType,
        mappedFormData.gridElectricityUsage,
        auth?.token
      );
    } else if (
      subscriptionPlan === "governance" &&
      facilityCategory === "non-green"
    ) {
      // Map form data to API expected field names 
      const mappedFormData = {
        baseLineFuelSource: formData.fuelSourceBaseline,
        projectFuelSource: formData.fuelSource === 'others'
          ? formData.fuelSourceOther
          : formData.fuelSource,
        baseLineScenario: formData.baseline,
        additionalInfomation: formData.additonalInfo,
        facilityStartDate: formData.projectStartDate,
        facilityEndDate: formData.projectEndDate,
      }
      response = await submitKycGovernanceNongreen(
        facilityCategory,
        subscriptionPlan,
        formData.facilityName,
        formData.facilityDescription,
        formData.facilityLocation,
        mappedFormData.facilityStartDate,
        mappedFormData.facilityEndDate,
        mappedFormData.projectFuelSource,
        mappedFormData.baseLineScenario,
        mappedFormData.baseLineFuelSource,
        mappedFormData.additionalInfomation,
        formData.proofOfFuelSource,
        formData.justificationStatement,
        auth?.token
      );
    } else if (
      subscriptionPlan === "governance" &&
      facilityCategory === "green"
    ) {
      // Map form data to API expected field names 

      const mappedFormData = {
        greenProjectName: formData.facilityName,
        greenProjectDescription: formData.facilityDescription,
        greenProjectLocation: formData.facilityLocation,
        greenProjectLicenseId: formData.greenProjectLicenseId,
        greenProjectStartDate: formData.projectStartDate,
        greenProjectEndDate: formData.projectEndDate,
        renewableEnergySolutions: formData.renewableEnergy,
        baseLineScenario: formData.baseline,
        baseLineEnergySource: formData.nonRenewableEnergySource === 'others'
          ? formData.nonRenewableEnergySourceOther
          : formData.nonRenewableEnergySource,
        additionalInfomation: formData.additonalInfo,

      };

      response = await submitKycGovernanceGreen(
        facilityCategory,
        subscriptionPlan,
        mappedFormData.greenProjectName,
        mappedFormData.greenProjectDescription,
        mappedFormData.greenProjectLocation,
        mappedFormData.greenProjectLicenseId,
        mappedFormData.greenProjectStartDate,
        mappedFormData.greenProjectEndDate,
        mappedFormData.renewableEnergySolutions,
        mappedFormData.baseLineScenario,
        mappedFormData.baseLineEnergySource,
        mappedFormData.additionalInfomation,
        formData.proofOfFuelSource,
        formData.justificationStatement,
        auth?.token
      );
    }
    else if (
      (subscriptionPlan === "business" || subscriptionPlan === "business-plus") &&
      facilityCategory === "green"
    ) {
      // Map form data to API expected field names 
      const mappedFormData = {
        greenProjectName: formData.facilityName,
        greenProjectDescription: formData.facilityDescription,
        greenProjectLocation: formData.facilityLocation,
        greenProjectLicenseId: formData.greenProjectLicenseId,
        greenProjectStartDate: formData.projectStartDate,
        greenProjectEndDate: formData.projectEndDate,
        renewableEnergySolutions: formData.renewableEnergy,
        baseLineScenario: formData.baseline,
        nonRenewableEnergySource: formData.nonRenewableEnergySource
          === 'others'
          ? formData.nonRenewableEnergySourceOther
          : formData.nonRenewableEnergySource,
        generatorFuelType: formData.generatorFuelType === 'others'
          ? formData.generatorFuelTypeOther
          : formData.generatorFuelType,
        gridElectricityUsage: formData.usesGridElectricity,
        additionalInfomation: formData.additonalInfo,
        utilityBill: formData.utilityBill,
        proofOfFuelSource: formData.proofOfFuelSource,
        justificationStatement: formData.justificationStatement,
      };

      response = await submitKycBusinessGreen(
        facilityCategory,
        subscriptionPlan,
        mappedFormData.greenProjectName,
        mappedFormData.greenProjectDescription,
        mappedFormData.greenProjectLocation,
        mappedFormData.greenProjectLicenseId,
        mappedFormData.greenProjectStartDate,
        mappedFormData.greenProjectEndDate,
        mappedFormData.renewableEnergySolutions,
        mappedFormData.baseLineScenario,
        mappedFormData.additionalInfomation,
        mappedFormData.proofOfFuelSource,
        mappedFormData.justificationStatement,
        mappedFormData.generatorFuelType,
        mappedFormData.utilityBill,
        mappedFormData.gridElectricityUsage,
        subscriptionPlan === 'business-plus' ? formData.tariffBand : null,
        subscriptionPlan === 'business-plus' ? formData.inverterRate : null,
        mappedFormData.nonRenewableEnergySource,
        auth?.token

      );
    }

    else if (
      subscriptionPlan === "business" &&
      facilityCategory === "non-green"
    ) {

      // Map form data to API expected field names 
      const mappedFormData = {
        baseLineFuelSource: formData.fuelSourceBaseline,
        projectFuelSource: formData.fuelSource === 'others'
          ? formData.fuelSourceOther
          : formData.fuelSource,
        baseLineScenario: formData.baseline,
        renewableEnergySource: formData.renewableEnergySource === 'others'
          ? formData.renewableEnergySourceOther
          : formData.renewableEnergySource,
        generatorFuelType: formData.generatorFuelType === 'others'
          ? formData.generatorFuelTypeOther
          : formData.generatorFuelType,
        gridElectricityUsage: formData.usesGridElectricity,
        additionalInfomation: formData.additonalInfo,
        projectName: formData.facilityName,
        projectDescription: formData.facilityDescription,
        projectLocation: formData.facilityLocation,
        projectStartDate: formData.projectStartDate,
        projectEndDate: formData.projectEndDate,
        proofOfFuelSource: formData.proofOfFuelSource,
        justificationStatement: formData.justificationStatement,
        utilityBill: formData.utilityBill,

      };
      response = await submitKycBusinessNongreen(
        facilityCategory,
        subscriptionPlan,
        mappedFormData.projectName,
        mappedFormData.projectDescription,
        mappedFormData.projectLocation,
        mappedFormData.projectStartDate,
        mappedFormData.projectEndDate,
        mappedFormData.projectFuelSource,
        mappedFormData.baseLineFuelSource,
        mappedFormData.baseLineScenario,
        mappedFormData.renewableEnergySource,
        mappedFormData.gridElectricityUsage,
        mappedFormData.generatorFuelType,
        mappedFormData.utilityBill,
        mappedFormData.additionalInfomation,
        mappedFormData.proofOfFuelSource,
        mappedFormData.justificationStatement,
        auth?.token
      );
    }
    else if (
      subscriptionPlan === "business" &&
      facilityCategory === "carbon-monitoring"
    ) {

      // Map form data to API expected field names 
      const mappedFormData = {
        generatorFuelType: formData.generatorFuelType === 'others'
          ? formData.generatorFuelTypeOther
          : formData.generatorFuelType,
        gridElectricityUsage: formData.usesGridElectricity,
        facilityStartDate: formData.projectStartDate,
        facilityEndDate: formData.projectEndDate,
      };
      response = await submitKycBusinessMonitoring(
        facilityCategory,
        subscriptionPlan,
        formData.facilityName,
        formData.facilityDescription,
        formData.facilityLocation,
        mappedFormData.facilityStartDate,
        mappedFormData.facilityEndDate,
        formData.solarElectricityUsage,
        mappedFormData.generatorFuelType,
        formData.utilityBill,
        mappedFormData.gridElectricityUsage,
        auth?.token
      );
    }

    console.log("response kyc", response);

    if (response?.data?.statusCode === 200) {
      toast.success(response?.data?.message);
      localStorage.removeItem("token");
      localStorage.setItem("token", response?.data?.token);

      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          token: response?.data?.token,
        },
      });

      push(ref(db, "notifications"), {
        type: "Incomplete Profile",
        read: false,
        user: auth?.userInfo?.id,
        timestamp: Date.now(),
      });

      push(ref(db, "notifications"), {
        type: "Validation in progress",
        read: false,
        user: auth?.userInfo?.id,
        timestamp: Date.now(),
      });
      push(ref(db, "kycStatus"), {
        status: "pending",
        user: auth?.userInfo?.id,
        timestamp: Date.now(),
      });
      setModalOpen(false);
    } else if (response?.data?.message === "KYC already submmitted") {
      toast.error(response?.data?.message);
      // dispatch({
      //   type: "KYC_SUBMIT_SUCCESS",
      //   payload: {
      //     token: auth?.token,
      //     data: {
      //       kycStatus: "pending",
      //     },
      //   },
      // });
    } else {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  const handleKycTwoSubmit = () => {
    if (facilityType === "") {
      alert("Please select a facility type(Green or Not Green)");
    } else if (scenario === "") {
      alert("Please select a carbon goal");
    } else {
      setModalOpenThree(false);
      handleModalOpen();
    }
  };

  const fileUpload = (e, documentTypeSent) => {
    setUploadLoading(true);

    let files = e;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            axios
              .post(
                `${process.env.REACT_APP_DEV_URL}/open/v1/upload`,
                {
                  media_type: "pdf",
                  folder: "documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                console.log("merddian", response);
                if (response?.data?.body?.success === true) {
                  if (documentTypeSent === "organizationBoundary") {
                    setOrganizationBoundary(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "reportingBoundary") {
                    setReportingBoundary(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "historicalInventory") {
                    setHistoricalInventory(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "typeofFuel") {
                    setTypeofFuel(response?.data?.body?.data[0]);
                  } else if (
                    documentTypeSent === "descriptionOfRenewableEnergySources"
                  ) {
                    setDescriptionOfRenewableEnergySources(
                      response?.data?.body?.data[0]
                    );
                  } else if (documentTypeSent === "projectMonitoringReport") {
                    setProjectMonitoringReport(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "projectDescriptionReport") {
                    setProjectDescriptionReport(response?.data?.body?.data[0]);
                  } else {
                    toast.error("document type not specified");
                  }
                }
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };

  const clickFileUpload = (e, documentTypeSent) => {
    setUploadLoading(true);

    let files = e.target.files;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            axios
              .post(
                `${process.env.REACT_APP_DEV_URL}/open/v1/upload`,
                {
                  media_type: "pdf",
                  folder: "documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                console.log("response", response);
                if (response?.data?.body?.success === true) {
                  if (documentTypeSent === "organizationBoundary") {
                    setOrganizationBoundary(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "reportingBoundary") {
                    setReportingBoundary(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "historicalInventory") {
                    setHistoricalInventory(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "typeofFuel") {
                    setTypeofFuel(response?.data?.body?.data[0]);
                  } else if (
                    documentTypeSent === "descriptionOfRenewableEnergySources"
                  ) {
                    setDescriptionOfRenewableEnergySources(
                      response?.data?.body?.data[0]
                    );
                  } else if (documentTypeSent === "projectMonitoringReport") {
                    setProjectMonitoringReport(response?.data?.body?.data[0]);
                  } else if (documentTypeSent === "projectDescriptionReport") {
                    setProjectDescriptionReport(response?.data?.body?.data[0]);
                  } else {
                    toast.error("document type not specified");
                  }
                }
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };

  const textValidation = (text, functionToCall) => {
    // Use regex to test for only letters
    const isLettersOnly = /^[A-Za-z'\s!@#$%^&*()_+=\[{\]};:<>,.?/\\|]+$/.test(
      text
    );
    if (text === "") {
      functionToCall(text);
    } else if (isLettersOnly) {
      functionToCall(text);
    } else {
      // alert('Please enter letters only');
    }
  };
  const numberValidation = (number, functionToCall) => {
    // Use regex to test for only letters
    const isLettersOnly = /^[-+]?[0-9.]+$/.test(number);

    if (number === "") {
      functionToCall(number);
    } else if (isLettersOnly) {
      functionToCall(number);
    } else {
      // alert('Please enter letters only');
    }
  };

  const addressValidation = (address, functionToCall) => {
    // Basic validation

    return true;
  };

  useEffect(() => {
    let dropAreas = document.querySelectorAll("#drag_drop");
    console.log("dropAreasdqew", dropAreas);
    dropAreas.forEach((dropArea) => {
      console.log("dropArea", dropArea);
      let uploadArea = document.querySelector(".admin_upload-area");
      ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
        dropArea.addEventListener(eventName, preventDefaults, false);
      });

      function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
      }

      ["dragenter", "dragover"].forEach((eventName) => {
        dropArea.addEventListener(eventName, highlight, false);
      });
      ["dragleave", "drop"].forEach((eventName) => {
        dropArea.addEventListener(eventName, unhighlight, false);
      });

      function highlight(e) {
        dropArea.classList.add("highlight");
        console.log("hunm", e);
        console.log("dropArea?.dataset", dropArea?.dataset);
      }

      function unhighlight(e) {
        dropArea.classList.remove("highlight");
      }

      dropArea.addEventListener("drop", handleDrop, false);

      function handleDrop(e) {
        console.log("dave dropped");
        console.log("e", e);
        console.log("e?.target", e?.target);
        console.log("e.target.files", e.target.files);
        console.log("e.dataTransfer", e.dataTransfer);
        console.log("e.dataTransfer.files", e.dataTransfer.files);
        if (dropArea?.dataset?.doctype === "organizationBoundary") {
          fileUpload(e.dataTransfer.files, "organizationBoundary");
          setDocumentType("organizationBoundary");
        } else if (dropArea?.dataset?.doctype === "historicalInventory") {
          fileUpload(e.dataTransfer.files, "historicalInventory");
          setDocumentType("historicalInventory");
        } else if (dropArea?.dataset?.doctype === "typeofFuel") {
          fileUpload(e.dataTransfer.files, "typeofFuel");
          setDocumentType("typeofFuel");
        } else if (dropArea?.dataset?.doctype === "projectDescriptionReport") {
          fileUpload(e.dataTransfer.files, "projectDescriptionReport");
          setDocumentType("projectDescriptionReport");
        } else if (dropArea?.dataset?.doctype === "projectMonitoringReport") {
          fileUpload(e.dataTransfer.files, "projectMonitoringReport");
          setDocumentType("projectMonitoringReport");
        } else if (
          dropArea?.dataset?.doctype === "descriptionOfRenewableEnergySources"
        ) {
          fileUpload(
            e.dataTransfer.files,
            "descriptionOfRenewableEnergySources"
          );
          setDocumentType("descriptionOfRenewableEnergySources");
        }
        // fileUpload(e.dataTransfer.files[0]);
        // console.log("e.dataTransfer", e.dataTransfer.files);
      }
    });
  }, [modalOpen]);

  const handleFailedIdVerificationModalOpen = () => {
    setFailedIdVerificationModal(true);
  };

  const handleFailedIdVerificationModalClose = (e) => {
    if (e.target.classList.contains("failed-id")) {
      setFailedIdVerificationModal(false);
    }
  };

  console.log("automatic", auth);
  console.log(
    'auth?.userInfo?.trdPtyKycStatus === "in_progress"',
    auth?.userInfo?.trdPtyKycStatus === "in_progress"
  );

  //  form rendering
  const renderForm = () => {
    if (!subscriptionPlan || !facilityCategory) {
      return <div>Loading form...</div>;
    }

    const commonProps = {
      onComplete: handleKycSubmit,
      userId: auth?.userInfo?.id,
      token: auth?.token,
      loading: loading
    };

    // Business subscription forms
    if (subscriptionPlan === "business" || subscriptionPlan === "business-plus") {
      if (facilityCategory === "green") {
        return (
          <KYCBusinessGreenForm
            {...commonProps}
            businessType={subscriptionPlan === 'business-plus' ? 'plus' : 'standard'}
          />
        );
      } else if (facilityCategory === "non-green") {
        return <KYCBusinessNonGreenForm {...commonProps} />;
      } else if (facilityCategory === "carbon-monitoring") {
        return <KYCBusinessMonitoringForm {...commonProps} />;
      }
    }
    // Basic subscription forms
    else if (subscriptionPlan === "basic") {
      if (facilityCategory === "green") {
        return <KYCBasicGreenForm {...commonProps} />;
      } else if (facilityCategory === "non-green") {
        return <KYCBasicNonGreen {...commonProps} />;
      }
    }
    // Governance subscription forms
    else if (subscriptionPlan === "governance") {
      if (facilityCategory === "green") {
        return <KYCGovernanceGreenForm {...commonProps} />;
      } else if (facilityCategory === "non-green") {
        return <KYCGovernanceNonGreenForm {...commonProps} />;
      } else if (facilityCategory === "carbon-monitoring") {
        return <KYCGovernanceMonitoringForm {...commonProps} />;
      }
    }
  }
  return (
    <>
      {modalOpen && (
        <div
          className="kyc_modal_container"
          onClick={handleModalClose}
        >
          {renderForm()}

        </div>
      )}
      {modalOpenThree && (
        <div
          className="kyc_modal_container"
        // onClick={handleModalCloseThree}
        >
          <div className="kyc_modal kyc_mini">
            <div className="title">Carbon Management Preferences</div>
            <div className="subtitle">
              Answer this questions, to start your journey
            </div>
            <div className="mini_grid_title">Green/Not Green</div>
            <div className="kyc_mini_grid">
              <div>
                Is your facility or operation committed to environmentally
                responsible practices, including the use of energy-efficient
                equipment and renewable energy sources?
              </div>
              <input
                checked={facilityType === "green"}
                type="checkbox"
                name=""
                id=""
                onChange={(e) => {
                  if (e.target.checked) {
                    setFacilityType("green");
                  } else {
                    setFacilityType("");
                  }
                }}
              />
            </div>
            <div className="kyc_mini_grid">
              <div>
                Does your facility primarily rely on conventional energy sources
                and equipment that may not prioritize environmental
                sustainability?
              </div>
              <input
                checked={facilityType === "non-green"}
                type="checkbox"
                name=""
                id=""
                onChange={(e) => {
                  if (e.target.checked) {
                    setFacilityType("non-green");
                  } else {
                    setFacilityType("");
                  }
                }}
              />
            </div>
            <div className="mini_grid_title">Carbon goals</div>
            {facilityType !== "green" && (
              <div className="kyc_mini_grid">
                <div>
                  Did you make infrastructure changes to reduce carbon emissions
                  and are interested in earning carbon incentives as a result?
                </div>
                <input
                  type="checkbox"
                  name=""
                  id=""
                  checked={scenario === "infrastructure-change"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setScenario("infrastructure-change");
                    } else {
                      setScenario("");
                    }
                  }}
                />
              </div>
            )}
            {facilityType !== "non-green" && (
              <div className="kyc_mini_grid">
                <div>
                  Are you looking to monitor your carbon and earn carbon
                  incentives through your green project
                </div>
                <input
                  type="checkbox"
                  name=""
                  id=""
                  checked={scenario === "green-project"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setScenario("green-project");
                    } else {
                      setScenario("");
                    }
                  }}
                />
              </div>
            )}
            {facilityType !== "green" && (
              <div className="kyc_mini_grid">
                <div>
                  Are you interested in just monitoring and tracking your carbon
                  emissions?
                </div>
                <input
                  type="checkbox"
                  name=""
                  id=""
                  checked={scenario === "carbon-monitoring"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setScenario("carbon-monitoring");
                    } else {
                      setScenario("");
                    }
                  }}
                />
              </div>
            )}
            <button className="kyc_submit" onClick={handleKycTwoSubmit}>
              Done
            </button>
          </div>
        </div>
      )}
      {uplaodLoading && <div className="upload_modal"></div>}
      {idVerificationModal && <div id="onfido-mount">
        {/* {loading && <div className="onfido-mount__loader">
          Loading...
        </div>} */}
      </div>}
      {failedIdVerificationModal && (
        <div
          className="failed-id"
          onClick={handleFailedIdVerificationModalClose}
        >
          <div className="failed-id__modal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V7M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7M16 8V10M8 8V10M9 16C9 16 10 17 12 17C14 17 15 16 15 16M12 8V13H11M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17M17 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V17"
                stroke="#D42620"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className="failed-id__modal__title">
              Id verification failed
            </div>
            <div className="failed-id__modal__subtitle">
              Something went wrong during verifying your Id.
            </div>
            <button
              className="failed-id__modal__button"
              onClick={() => {
                setFailedIdVerificationModal(false);
              }}
            >
              Try again
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Kyc;
